function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@ori-ui/components';
import { MenuItem, Select, styled, Typography } from '@ori-ui/mui';
import { useState } from 'react';
import { Localization } from '../Localization';
import { Account } from '../components';
import { defaultTranslations } from '../constants/defaultTranslations';
import { useConfiguration } from '../contexts';
import { TranslationKey } from '../models';
import { isNullOrUndefinedOrEmpty } from '../utils';
var PlaceholderStyled = styled(Typography)(function(param) {
    var theme = param.theme;
    return {
        color: theme.palette.grey[300]
    };
});
var TenantStyled = styled('div')(function(param) {
    var theme = param.theme;
    return {
        margin: theme.spacing(23, 'auto', 0),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flexDirection: 'column'
    };
});
var ButtonStyled = styled(Button)(function(param) {
    var theme = param.theme;
    return {
        '&.MuiButton-root.MuiButton-contained': {
            margin: theme.spacing(23, 'auto', 4),
            width: '100%'
        }
    };
});
var renderValue = function(options, placeholder) {
    return function(inputValue) {
        var displayValue = options.find(function(i) {
            return i.value === inputValue;
        });
        if (isNullOrUndefinedOrEmpty(inputValue) || inputValue === 0) {
            return /*#__PURE__*/ _jsx(PlaceholderStyled, {
                children: placeholder
            });
        }
        var _displayValue_text;
        return /*#__PURE__*/ _jsx("span", {
            children: (_displayValue_text = displayValue === null || displayValue === void 0 ? void 0 : displayValue.text) !== null && _displayValue_text !== void 0 ? _displayValue_text : ''
        });
    };
};
var TenantSelect = function() {
    var _availableOptions_;
    var availableTenants = useConfiguration().availableTenants;
    var _useState = _sliced_to_array(useState(''), 2), selectedTenant = _useState[0], setSelectedTenant = _useState[1];
    var availableOptions = availableTenants.map(function(opt) {
        return {
            name: opt.text,
            value: opt.value
        };
    });
    var _availableOptions__value;
    var defaultValue = (_availableOptions__value = (_availableOptions_ = availableOptions[0]) === null || _availableOptions_ === void 0 ? void 0 : _availableOptions_.value) !== null && _availableOptions__value !== void 0 ? _availableOptions__value : '';
    return /*#__PURE__*/ _jsx(Account, {
        title: /*#__PURE__*/ _jsx(Localization, {
            defaultMessage: defaultTranslations.SignInTitle,
            id: TranslationKey.SignInTitle
        }),
        children: /*#__PURE__*/ _jsxs(TenantStyled, {
            children: [
                /*#__PURE__*/ _jsx(Localization, {
                    defaultMessage: defaultTranslations.SelectCountry,
                    id: TranslationKey.SelectCountry
                }),
                /*#__PURE__*/ _jsx(Select, {
                    displayEmpty: true,
                    sx: {
                        width: '100%'
                    },
                    defaultValue: defaultValue,
                    renderValue: renderValue(availableTenants, /*#__PURE__*/ _jsx(Localization, {
                        defaultMessage: defaultTranslations.SelectCountryPlaceholder,
                        id: TranslationKey.SelectCountryPlaceholder
                    })),
                    onChange: function(e) {
                        return setSelectedTenant(e.target.value);
                    },
                    children: availableTenants.map(renderSelectOption)
                }),
                /*#__PURE__*/ _jsx(ButtonStyled, {
                    variant: "contained",
                    color: "primary",
                    disabled: !selectedTenant,
                    onClick: function() {
                        return handleTenantClick(selectedTenant);
                    },
                    children: /*#__PURE__*/ _jsx(Localization, {
                        defaultMessage: defaultTranslations.Continue,
                        id: TranslationKey.Continue
                    })
                })
            ]
        })
    });
};
function handleTenantClick(selectedTenant) {
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.append('tenant', selectedTenant);
    window.location.href = currentUrl.href;
}
function renderSelectOption(item, index) {
    return /*#__PURE__*/ _jsx(MenuItem, {
        value: item.value,
        children: item.text
    }, index);
}
export default TenantSelect;
